import { Link } from "react-router-dom";
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import { Box } from '@mui/material';
import cssStyles from "src/styles/_error.module.css";
 
// 접근 제한 안내 페이지 정의
 const NoEntryPage = ({
   message = "Only administrators can access this page. Please contact an admin if you believe this is an error.",
 }: {
   message?: string;
 }) => {
   return (
     <div id="next">
       <div className={cssStyles["css-1i1mpo0"]}>
         <div
           style={{
             fontFamily:
               "-apple-system, BlinkMacSystemFont, Roboto, 'Segoe UI', 'Fira Sans', Avenir, 'Helvetica Neue', 'Lucida Grande', sans-serif",
             height: "100vh",
             textAlign: "center",
             display: "flex",
             flexDirection: "column",
             alignItems: "center",
             justifyContent: "center",
           }}
         >
           <div>
             <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', mt:2, mb:2}}>
                 <NotInterestedIcon sx={{color:"red" , width: 80 , height : 80}}/>
             </Box>
             <div
               style={{
                 display: "inline-block",
                 lineHeight: "49px",
                 height: "49px",
                 verticalAlign: "middle",
               }}
             >
               <h2
                 style={{
                   fontSize: "20px",
                   fontWeight: "normal",
                   lineHeight: "inherit",
                   margin: 0,
                   padding: 0,
                 }}
               >
                 {message}
               </h2>
               <Box>
                 <Link to="/dashboard" style={{ textDecoration: 'none', color: '#1976d2', fontSize: '16px' }}>
                   Go back to Dashboard Page
                 </Link>
               </Box>
             </div>
           </div>
         </div>
       </div>
     </div>
   );
 };
 
	 export default NoEntryPage;
